import axios from "axios";
import { useModal, useToast } from "@/comn/hooks";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";

export const useFindPassword = (initialUsrId: string = "") => {
    const modal = useModal();
    const navigate = useNavigate();
    const { showToast } = useToast();
    const { t } = useTranslation();

    const [findPasswordForm, setFindPasswordForm] = useState({
        usrId: initialUsrId,
        usrEmlAddr: "",
        isLcm: false,
    });

    const handleSubmitFindPassword = async (event: any) => {
        event.preventDefault();

        const { usrId, usrEmlAddr, isLcm } = findPasswordForm;

        try {
            const caseMap: any = {
                tanoga: {
                    url: "/api/v1/osci/mypage/myinfochg/findpwd",
                    payload: { usrIdntfNo: usrId, usrEmlAddr },
                },
            };

            const key = "tanoga";
            const base = process.env.REACT_APP_API_OSCI;
            const response = await axios.post(base + caseMap[key].url, caseMap[key].payload, {
                headers: { "Accept-Language": Cookies.get("lang")?.toUpperCase() || "EN" },
            });
            console.log("response", response);
            if (response.status == 201 || response.status == 200) {
                modal.openModal({
                    content: (
                        <div>
                            {t("L_NEW_PWD")} : {response.data?.randomUsrPwd?.content}
                        </div>
                    ),
                    onClose: () => {
                        navigate("/login");
                    },
                });
            }
        } catch (error: any) {
            console.log(error);
            showToast({ content: error.response?.data?.errorMessage || "error", type: "error" });
        }
    };

    return { findPasswordForm, setFindPasswordForm, handleSubmitFindPassword };
};
